(function () {
    'use strict';

    angular
        .module('app.paymentTransactions')
        .controller('PaymentTransactionsListController', PaymentTransactionsListController);

    PaymentTransactionsListController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function PaymentTransactionsListController(common, dataservice) {
        var vm = this;

        vm.title = 'Payment Transactions';
        vm.displayedItems = [];
        vm.items = [];
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.hasSearched = false;
        vm.openDatePicker = openDatePicker;
        vm.isCollegeNet = common.userService.isCollegeNetApi();
        vm.dpStatus = {
            fromDateOpen: false,
            toDateOpen: false
        }
        vm.filters = {
            fromDate: new Date(),
            toDate: new Date()
        }
        vm.datePickerOptions = {
            showWeeks: false,
            ngModelOptions: {
                allowInvalid: false
            }
        };
        vm.getItems = getItems;

        activate();


        function openDatePicker(isStart) {
            if (isStart) {
                vm.dpStatus.fromDateOpen = true;
                vm.dpStatus.toDateOpen = false;
            }
            else {
                vm.dpStatus.fromDateOpen = false;
                vm.dpStatus.toDateOpen = true;
            }

        }
        function activate() {
            var promises = [getLookups(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
                var billingDept = common.userService.billingDepartmentIds();
                
                if (billingDept.length === 1) {
                    vm.filters.EmsDepartmentId = Number(billingDept[0]);
                }
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = vm.licenseInfo.NumberOfPaymentTemplatesLicensed >= vm.licenseInfo.NumberOfPaymentTemplatesInUse;
                return vm.licenseInfo;
            }, function (error) { });
        }
     
        function getItems() {
            return dataservice.query('api/PaymentTransactions/Search', vm.filters).then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                vm.hasSearched = true;
                return vm.items;
            }, function (error) { });
        }

        function getLookups() {
            return dataservice.getItems('api/PaymentTransactions/GetLookups').then(function (response) {
                vm.departments = response.data.Departments;
                
            }, function (error) { });
        }

    }
})();
